import { useMemo } from 'react';
import { makeRootClassName } from '../../../utils';
export var useBoxClassName = function useBoxClassName(classPrefix, className) {
  return useMemo(function () {
    var rootClassNames = makeRootClassName(classPrefix, className);
    return {
      Root: rootClassNames
    };
  }, [classPrefix, className]);
};